module.exports = __webpack_public_path__ + "static/img/interview-2-3.8cbecd4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/interview-2-3.png
// module id = rfMV
// module chunks = 1